import { LoginState } from '../../store/state';
import { LoginAction, LoginActions } from '../actions';

const initialState: LoginState = {
  apiOptions: null,
  authed: '',
  errorText: '',
  sessionToken: '',
  sessionTokenExpiration: null,
  isLoading: false,
};

const loginReducer = (state: LoginState = initialState, action: LoginAction) => {
  switch (action.type) {
    case LoginActions.LoginRequest:
      return {
        ...state,
        apiOptions: action.apiOptions,
        errorText: '',
        isLoading: true,
      };
    case LoginActions.LoginSuccess:
      return {
        ...state,
        authed: action.payload.authed,
        sessionToken: action.payload.sessionToken,
        sessionTokenExpiration: action.payload.sessionTokenExpiration,
        errorText: action.payload.errorText,
        isLoading: false,
      };
    case LoginActions.LoginError:
      return {
        ...state,
        authed: action.payload.authed,
        sessionToken: action.payload.sessionToken,
        sessionTokenExpiration: action.payload.sessionTokenExpiration,
        errorText: action.payload.errorText,
        isLoading: false,
      };
    case LoginActions.LogoutSuccess:
      return {
        ...state,
        authed: false,
        sessionToken: '',
        sessionTokenExpiration: null,
        errorText: '',
      };
    case LoginActions.LogoutFailed:
      return {
        ...state,
        errorText: action.payload,
      };
    default:
      return state;
  }
};

export default loginReducer;
